import {createSlice} from "@reduxjs/toolkit";
import {setTicketComparePageCriteria, TicketComparePageCriteria} from "./actions";

type TicketComparePageState = {
  criteria?: TicketComparePageCriteria
}

const INITIAL_STATE: Readonly<TicketComparePageState> = {
  criteria: undefined,
};

const ticketComparePageUISlice = createSlice({
  name: "ots-ui/ticket-compare-page",
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      setTicketComparePageCriteria,
      (state, {payload}) => {
        state.criteria = payload
      }
    );
  }
});

export const ticketComparePageUIReducer = ticketComparePageUISlice.reducer;
